import {
    ADDRESS_TYPES,
    QUALIFICATION_TYPES,
    RELATIONSHIP
  } from "../../constants/constants";
  import { getAddressDetails } from "../../util/candidateDataFilters";
  import {
    decrypt,
    getFormattedDate,
    getGenderName,
    getLastOrganization,
    getMaritalName,
    getQualificationByID,
    getStatusDescription,
    isDateExistsInbetween
  } from "../../util/helpers";
  import {
    findTotalExperienceInDays,
    getBloodGroup,
    getCSRAmount,
    getDeclarationPlace,
    getNationality,
    getNoOfYearsMonthsDaysString,
    getQualificationDetails,
    getRelationDetails,
    getStateName,
    getTitle
  } from "../../util/onBoardingDataFilters";
  
  export const candidateDetailsConfig = (
    candidates,
    candidateStatus,
    fromDate,
    toDate,
    statesList,
    genders,
    maritalTypes
  ) => {
    let filteredEmployees;
  
    candidateStatus = String(candidateStatus);
    filteredEmployees =
      candidates && (candidateStatus || fromDate || toDate)
        ? candidates.map(employee => {
            let isFilteredByCandidateStatus;
            let isFilteredByDates;
  
            if (candidateStatus && employee.status == candidateStatus) {
              isFilteredByCandidateStatus = true;
            }
  
            if (
              employee.userDetails && 
              employee.userDetails.dateofJoining &&
              isDateExistsInbetween(
                employee.userDetails.dateofJoining,
                fromDate,
                toDate
              )
            ) {
              isFilteredByDates = true;
            }
  
            if (
              candidateStatus &&
              (fromDate || toDate) &&
              isFilteredByCandidateStatus &&
              isFilteredByDates
            ) {
              return employee;
            } else if (
              candidateStatus &&
              !(fromDate || toDate) &&
              isFilteredByCandidateStatus
            ) {
              return employee;
            } else if (
              !candidateStatus &&
              (fromDate || toDate) &&
              isFilteredByDates
            ) {
              return employee;
            }
  
            return undefined;
          })
        : candidates || [];
  
    filteredEmployees = filteredEmployees.filter(a => a);
  
    return [
      {
        columns: [
          {
            title: "Employee ID",
            width: { wch: 14 }
          },
          {
            title: "Status",
            width: { wch: 14 }
          },
          {
            title: "Title(Mr/Ms)",
            width: { wch: 14 }
          },
          {
            title: "First Name",
            width: { wch: 14 }
          },
          {
            title: "Middle Name",
            width: { wch: 14 }
          },
          {
            title: "Last Name",
            width: { wch: 14 }
          },
          {
            title: "Employee Location",
            width: { wch: 14 }
          },
          {
            title: "Date Of Birth",
            width: { wch: 14 }
          },
          {
            title: "Gender",
            width: { wch: 14 }
          },
          {
            title: "Marital Status",
            width: { wch: 14 }
          },
          {
            title: "Marriage Date",
            width: { wch: 14 }
          },
          {
            title: "Designation/Business Title",
            width: { wch: 20 }
          },
          {
            title: "Date Of Joining",
            width: { wch: 14 }
          },
          {
            title: "Blood Group",
            width: { wch: 14 }
          },
          {
            title: "PAN",
            width: { wch: 14 }
          },
          {
            title: "Aadhar Number",
            width: { wch: 14 }
          },
          {
            title: "Personal Email ID",
            width: { wch: 20 }
          },
          {
            title: "Current Address - Line1",
            width: { wch: 20 }
          },
          {
            title: "Current Address - Line2",
            width: { wch: 20 }
          },
          {
            title: "Current Address - Line3",
            width: { wch: 20 }
          },
          {
            title: "Current Address - City",
            width: { wch: 20 }
          },
          {
            title: "Current Address - Pincode",
            width: { wch: 20 }
          },
          {
            title: "Current Address State",
            width: { wch: 16 }
          },
          {
            title: "Current Address - Contact Number",
            width: { wch: 24 }
          },
          {
            title: "Permanent Address - Line1",
            width: { wch: 20 }
          },
          {
            title: "Permanent Address - Line2",
            width: { wch: 20 }
          },
          {
            title: "Permanent Address - Line3",
            width: { wch: 20 }
          },
          {
            title: "Permanent Address - City",
            width: { wch: 20 }
          },
          {
            title: "Permanent Address - Pincode",
            width: { wch: 20 }
          },
          {
            title: "Permanent Address - Contact Number",
            width: { wch: 24 }
          },
          {
            title: "Permanent Address State",
            width: { wch: 16 }
          },
          {
            title: "Nationality",
            width: { wch: 14 }
          },
          {
            title: "Last Organization",
            width: { wch: 18 }
          },
          {
            title: "Job Title",
            width: { wch: 16 }
          },
          {
            title: "Total Exp",
            width: { wch: 24 }
          },
          {
            title: "Degree",
            width: { wch: 14 }
          },
          {
            title: "Qualification",
            width: { wch: 14 }
          },
          {
            title: "Year of Passing",
            width: { wch: 14 }
          },
          {
            title: "Specialization",
            width: { wch: 14 }
          },
          {
            title: "University",
            width: { wch: 18 }
          },
          {
            title: "State",
            width: { wch: 18 }
          },
          {
            title: "% of CGPA",
            width: { wch: 14 }
          },
          {
            title: "Last Degree",
            width: { wch: 14 }
          },
          {
            title: "Last Qualification",
            width: { wch: 16 }
          },
          {
            title: "Year of Passing",
            width: { wch: 14 }
          },
          {
            title: "Specialization",
            width: { wch: 14 }
          },
          {
            title: "University",
            width: { wch: 16 }
          },
          {
            title: "State",
            width: { wch: 14 }
          },
          {
            title: "% of CGPA",
            width: { wch: 14 }
          },
          {
            title: "Emergency Contact Person",
            width: { wch: 18 }
          },
          {
            title: "Emergency Contact Relation",
            width: { wch: 18 }
          },
          {
            title: "Emergency Contact Phone",
            width: { wch: 18 }
          },
          {
            title: "Emergency Contact Mobile",
            width: { wch: 18 }
          },
          {
            title: "Father Name",
            width: { wch: 14 }
          },
          {
            title: "Father DOB",
            width: { wch: 14 }
          },
          {
            title: "Mother Name",
            width: { wch: 14 }
          },
          {
            title: "Mother DOB",
            width: { wch: 14 }
          },
          {
            title: "Spouse Name",
            width: { wch: 14 }
          },
          {
            title: "Spouse DOB",
            width: { wch: 14 }
          },
          {
            title: "Child 1 Name",
            width: { wch: 14 }
          },
          {
            title: "Child 1 DOB",
            width: { wch: 14 }
          },
          {
            title: "Child 2 Name",
            width: { wch: 14 }
          },
          {
            title: "Child 2 DOB",
            width: { wch: 14 }
          },
          {
            title: "Religion",
            width: { wch: 14 }
          },
          {
            title: "UAN",
            width: { wch: 14 }
          },
          {
            title: "PF Number",
            width: { wch: 14 }
          },
          {
            title: "CSR contribution amount",
            width: { wch: 20 }
          },
          {
            title: "Bank Name",
            width: { wch: 14 }
          },
          {
            title: "IFSC",
            width: { wch: 14 }
          },
          {
            title: "Account Number",
            width: { wch: 18 }
          },
          {
            title: "Branch",
            width: { wch: 14 }
          },
          {
            title: "Location",
            width: { wch: 14 }
          }
        ],
        data: filteredEmployees.length
          ? filteredEmployees.map((employee) => {
              const employeeDetails = employee.userDetails;
  
              const currentAddress = getAddressDetails(
                ADDRESS_TYPES.CURRENT,
                employeeDetails.addresses
              );
  
              const permanentAddress = getAddressDetails(
                ADDRESS_TYPES.PERMANENT,
                employeeDetails.addresses
              );
  
              const graduationDetails = getQualificationDetails(
                QUALIFICATION_TYPES.GRADUATION,
                employeeDetails.qualifications
              ) || {};
  
              const postGraduationDetails = getQualificationDetails(
                QUALIFICATION_TYPES.POSTGRADUATION,
                employeeDetails.qualifications
              ) || {};
  
              // Treating Graduation to be minimum qualification.
              const lastDegreeDetails =
                postGraduationDetails && postGraduationDetails.qualificationId
                  ? postGraduationDetails
                  : graduationDetails;
  
              const lastOrganization = getLastOrganization(
                employeeDetails.organizationDetails
              ) || {};
  
              const father = getRelationDetails(
                RELATIONSHIP.FATHER.id,
                employeeDetails.familyMembers
              );
              const mother = getRelationDetails(
                RELATIONSHIP.MOTHER.id,
                employeeDetails.familyMembers
              );
              const spouse = getRelationDetails(
                RELATIONSHIP.HUSBAND.id,
                employeeDetails.familyMembers
              );
              const childOne = getRelationDetails(
                4,
                employeeDetails.familyMembers
              );
              const childTwo = getRelationDetails(
                5,
                employeeDetails.familyMembers
              );
  
              return [
                {
                  value: employeeDetails.cDKEmployeeId || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getStatusDescription(employee.status) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getTitle(employeeDetails.title) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.firstName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.middleName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.lastName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value:
                    getDeclarationPlace(employeeDetails.declarationPlace) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(employeeDetails.birthDate) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getGenderName(employeeDetails.gender, genders) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value:
                    getMaritalName(employeeDetails.maritalStatus, maritalTypes) ||
                    "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(employeeDetails.anniversaryDate) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.cDKDesignation || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(employeeDetails.dateofJoining) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getBloodGroup(employeeDetails.bloodGroup) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.panCardNo) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.adhaarNumber) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.emailId,
                  style: { font: { sz: "12" } }
                },
                {
                  value: currentAddress.addressLine1 || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: currentAddress.addressLine2 || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: currentAddress.locality || "", // Current Address - Line3
                  style: { font: { sz: "12" } }
                },
                {
                  value: currentAddress.city || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: currentAddress.pincode || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getStateName(currentAddress.state, statesList) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.alternateContactNo || "-", // Current Address - Contact Number
                  style: { font: { sz: "12" } }
                },
                {
                  value: permanentAddress.addressLine1 || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: permanentAddress.addressLine2 || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: permanentAddress.locality || "", // Permanent Address - Line3
                  style: { font: { sz: "12" } }
                },
                {
                  value: permanentAddress.city || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: permanentAddress.pincode || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.contactNumber || "-", // Permanent Address - Contact Number
                  style: { font: { sz: "12" } }
                },
                {
                  value: getStateName(permanentAddress.state, statesList) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getNationality(employeeDetails.nationality) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastOrganization.organizationName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastOrganization.jobTitle || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value:
                    getNoOfYearsMonthsDaysString(
                      findTotalExperienceInDays(
                        employeeDetails
                      )
                    ) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: graduationDetails.degree || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: "GRADUATION", // Qualification
                  style: { font: { sz: "12" } }
                },
                {
                  value: graduationDetails.completionYear || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: graduationDetails.specialization || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: graduationDetails.university || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getStateName(graduationDetails.state, statesList) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: graduationDetails.grade || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastDegreeDetails.degree || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getQualificationByID(lastDegreeDetails.qualificationId) || "", // Last Qualification
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastDegreeDetails.completionYear || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastDegreeDetails.specialization || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastDegreeDetails.university || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getStateName(lastDegreeDetails.state, statesList) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: lastDegreeDetails.grade || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.emergencyPersonName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.relationWithMe || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: "-", // Emergency Contact Phone
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.emergencyContactNo || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: father.fullName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(father.dateOfBirth) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: mother.fullName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(mother.dateOfBirth) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: spouse.fullName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(spouse.dateOfBirth) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: childOne.fullName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(childOne.dateOfBirth) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: childTwo.fullName || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getFormattedDate(childTwo.dateOfBirth) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: employeeDetails.religion || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.pfUanNo) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.previousPFNumber) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: getCSRAmount(employeeDetails.cSRContribution) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.bankName) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.bankIFSCCode) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.bankAccountNumber) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.bankBranch) || "",
                  style: { font: { sz: "12" } }
                },
                {
                  value: decrypt(employeeDetails.bankLocation) || "",
                  style: { font: { sz: "12" } }
                }
              ];
            })
          : []
      }
    ];
  };